import { Stack } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AuthorMinStdHeader } from '@/module/MinimalStandard/perRole/AuthorMinStdHeader';
import { DepartmentAdminMinStdHeader } from '@/module/MinimalStandard/perRole/DepartmentAdminMinStdHeader';
import { DisciplineAdminMinStdHeader } from '@/module/MinimalStandard/perRole/DisciplineAdminMinStdHeader';
import { FacultyAdminMinStdHeader } from '@/module/MinimalStandard/perRole/FacultyAdminMinStdHeader';
import { UniversityAdminMinStdHeader } from '@/module/MinimalStandard/perRole/UniversityAdminMinStdHeader';

import { NoContentPlaceholder } from '@/core/components';

import { useCurrentUser } from '@feature/security';

const minStdSearchSchema = z.object({
  userId: z.coerce.number().nullish(),
  disciplineId: z.coerce.number().nullish(),
  departmentId: z.coerce.number().nullish(),
  facultyId: z.coerce.number().nullish(),
});

export const Route = createFileRoute('/_auth/minimal-standards/_layout')({
  staticData: {
    pageTitle: { id: 'sidebar.minimalStandards' },
  },
  validateSearch: minStdSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { currentRole } = useCurrentUser();
  const hasAccess =
    ['AUTHOR', 'UNIVERSITY_ADMIN', 'DISCIPLINE_ADMIN', 'DEPARTMENT_ADMIN', 'FACULTY_ADMIN'].indexOf(currentRole) !== -1;

  if (!hasAccess) {
    return (
      <NoContentPlaceholder title="Nu aveți acces la acest ecran cu acest rol. Asigurați-vă că folosiți un rol de autor sau șef de disciplină / director departament sau decan" />
    );
  }

  return (
    <Stack p="sm">
      {currentRole === 'UNIVERSITY_ADMIN' && <UniversityAdminMinStdHeader />}
      {currentRole === 'FACULTY_ADMIN' && <FacultyAdminMinStdHeader />}
      {currentRole === 'DEPARTMENT_ADMIN' && <DepartmentAdminMinStdHeader />}
      {currentRole === 'DISCIPLINE_ADMIN' && <DisciplineAdminMinStdHeader />}
      {currentRole === 'AUTHOR' && <AuthorMinStdHeader />}
    </Stack>
  );
}
